import { render, staticRenderFns } from "./Recaptcha.vue?vue&type=template&id=ff57674a&scoped=true"
import script from "./Recaptcha.vue?vue&type=script&lang=js"
export * from "./Recaptcha.vue?vue&type=script&lang=js"
import style0 from "./Recaptcha.vue?vue&type=style&index=0&id=ff57674a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff57674a",
  null
  
)

export default component.exports